import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  DateField,
  ReferenceArrayField,
  EditButton,
  SingleFieldList,
  ChipField,
} from 'react-admin';

const PromoList = props => (
  <List {...props} bulkActionButtons={false}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="name" />
      <ReferenceArrayField label="Objective" reference="objectives" source="objective_ids" allowEmpty>
        <SingleFieldList linkType={false}>
          <ChipField source="name" />
        </SingleFieldList>
      </ReferenceArrayField>
      <DateField source="created_at" showTime />
      <EditButton />
    </Datagrid>
  </List>
);

export default PromoList;



// WEBPACK FOOTER //
// ./src/resources/tags/TagList.jsx